import { trackDistribution, trackMetric } from './Telemetry.js'

/**
 * Sample-file upload telemetry. File sizes/counts are distributions (so we get p50/p95 etc. of the
 * data volume customers push); outcome is a counter for success/failure rate. Fired from the single
 * Uppy chokepoint in UppyProvider, so it covers every upload entry point.
 */

/** Per-file size in bytes (rendered as KB/MB in Sentry). */
export const trackUploadFileSize = (bytes: number, itemType?: string): void => {
  trackDistribution('upload.file_size', bytes, { item_type: itemType }, 'byte')
}

/** How many files were added in one upload batch. */
export const trackUploadFileCount = (count: number): void => {
  trackDistribution('upload.file_count', count)
}

/** Upload outcome — group by `outcome` for the success/failure rate. */
export const trackUploadOutcome = (outcome: 'success' | 'error', itemType?: string): void => {
  trackMetric('upload.outcome', { outcome, item_type: itemType })
}
